import { ColumnFieldTitle, FieldSet, OfbizForm, OfbizList } from "@urbannex/ofbiz-forms";
import { ConfigOptions, CustomContainerItem, getFields, ProductEditContainerComponent } from "@urbannex/view-containers";
import { PROD_FORMS } from "./forms";

export const options: ConfigOptions = {
    name: "",
    title: "Products Component",
    appContext: "catalog",
    defaultParameters: [
        { productCategoryId: "CATALOG1_SEARCH" }
    ],
    menuAndTitleOptions: {
        path: "products",
        headerTitle: "Product Information",
        menuItems: [],
        menuTag: "productsMenu"
    },
    listForm: new OfbizList({
        listType: "grid",
        fieldFormName: "",
        fieldFormLocation: "local",
        listFormName: "ListProductCategoryMembers", // "ListProducts",
        // listFormLocation:"component://product/widget/catalog/ProductForms.xml",
        listFormLocation: "component://kwikstore/widget/ProductForms.xml",
        // columnFields:getFields("ListProducts",PROD_FORMS),
        columnFields: getFields("ListProductCategoryMembers", PROD_FORMS),
        // columnFieldTitles:getColumnFieldTitles("ListProducts",PROD_FORMS),
        columnFieldTitles: getColumnFieldTitles("ListProductCategoryMembers", PROD_FORMS),
        remoteFormData: {
            formData: {
                formName: "ListProductCategoryMembers",
                formLocation: "component://kwikstore/widget/ProductForms.xml",
                listType: "grid",
                entityName: "",
                viewIndex: 0,
                viewSize: 20
            },
            parameters: { "productCategoryId": "CATALOG1_SEARCH" }
        },
        appContext: "catalog",
        emptyListMessage: "No products found.  Please create new or add existing."
    }),
    findForm: undefined,
    addForm: new OfbizForm({
        local: true,
        formName: "EditProductRest",
        formLocation: "component://kwikstore/widget/ProductForms.xml",
        fields: getFields("EditProductRest", PROD_FORMS),
        titleDescriptionField: getTitleDescriptionField("EditProductRest", PROD_FORMS),
        idFieldName: getIdFieldName("EditProductRest", PROD_FORMS),
        renderComponent: "EditProduct",
        fieldSets: getFieldSets("EditProductRest", PROD_FORMS),
        breadCrumbData: {
            displayPrefix: "Edit Product",
            label: "",
            level: 1,
            selectedValue: {
                "event": "edit",
                "type": "EditProductRest",
                "data": {
                    formData: {
                        listType: "edit",
                        formName: "EditProductRest",
                        formLocation: "component://kwikstore/widget/ProductForms.xml",
                    },
                    "endPoint": "",
                    "parameters": { "producId": "" }
                }
            },
        }
    }),
    breadCrumbData: {
        displayPrefix: "Products ",
        label: "",
        level: 1,
        selectedValue: {
            "event": "list",
            "type": "ListProducts",
            "data": {
                formData: {
                    listType: "grid",
                    // formName:"ListProducts",
                    formName: "ListProductCategoryMembers",
                    // formLocation:"component://product/widget/catalog/ProductForms.xml",
                    formLocation: "component://kwikstore/widget/ProductForms.xml",
                },
                "endPoint": "",
                // "parameters":{"productCategoryId":"","noConditionFind":"Y"}
                "parameters": { "productCategoryId": "" }
            }
        },
        addFormText: "Create Product",
        editFormText: "Update Product"
    },
    actions: [],
    settings: [],
    relations: [
        {
            title: "Prices",
            titleGroup: "Product Financials",
            keyMap: { fieldName: "productId" },
            path: "prices",
            addContainerTitle: "Create new price for",
            listContainerTitle: "Prices for",
            addFormName: "",
            listFormName: "",
            addForm: new OfbizForm({
                formName: "AddProductPriceRest",
                formLocation: "component://kwikstore/widget/ProductForms.xml",
                fields: getFields("AddProductPriceRest", PROD_FORMS),
                target: getTarget("AddProductPriceRest", PROD_FORMS),
                appContext: "catalog",
                layout: "SingleColumn",
                local: true,
                entityName: "ProductPrice"
            }),
            listForm: new OfbizList({
                listFormLocation: "component://kwikstore/widget/ProductForms.xml",
                listFormName: "UpdateProductPriceRest",
                listType: "grid",
                columnFields: getFields("UpdateProductPriceRest", PROD_FORMS),
                columnFieldTitles: getColumnFieldTitles("UpdateProductPriceRest", PROD_FORMS),
                emptyListMessage: "No prices found.  Please add existing or create new.",
                remoteFormData: {
                    formData: {
                        formName: "UpdateProductPriceRest",
                        formLocation: "component://kwikstore/widget/ProductForms.xml",
                        listType: "grid",
                        viewIndex: 0,
                    },
                    appContext: "catalog",
                    parameters: { "productCategoryId": "" }
                }
            })
        },
        {
            title: "Content",
            keyMap: { fieldName: "productId" },
            path: "content",
            addContainerTitle: "Add existing content to ",
            listContainerTitle: "Associated Content for ",
            addFormName: "ListProductContentInfosRest",
            listFormName: "",
            addForm: new OfbizForm({
                local: true,
                formName: "AddProductContentAssocRest",
                formLocation: "component://kwikstore/widget/ProductForms.xml",
                fields: getFields("AddProductContentAssocRest", PROD_FORMS),
                titleDescriptionField: getTitleDescriptionField("AddProductContentAssocRest", PROD_FORMS),
                idFieldName: getIdFieldName("AddProductContentAssocRest", PROD_FORMS),
            }),
            listForm: new OfbizList({
                listType: "grid",
                fieldFormName: "",
                fieldFormLocation: "local",
                listFormName: "ListProductContentInfosRest",
                listFormLocation: "component://kwikstore/widget/ProductForms.xml",
                columnFields: getFields("ListProductContentInfosRest", PROD_FORMS),
                columnFieldTitles: getColumnFieldTitles("ListProductContentInfosRest", PROD_FORMS),
                emptyListMessage: "No content found.  Please add existingor create new.",
                remoteFormData: {
                    formData: {
                        formName: "ListProductContentInfosRest",
                        formLocation: "component://kwikstore/widget/ProductForms.xml",
                        listType: "grid",
                        viewIndex: 0,
                    },
                    appContext: "catalog",
                    parameters: { "productCategoryId": "" }
                }
            })
        },
        {
            title: "Geos",
            titleGroup: "Product Classification",
            path: "geos",
            keyMap: { fieldName: "productId" },
            addContainerTitle: "Add geography to product",
            listContainerTitle: "Geographies for product",
            addFormName: "AddProductGeo",
            listFormName: "ListProductGeos",
            addForm: new OfbizForm({
                formName: "AddProductGeo",
                formLocation: "component://kwikstore/widget/ProductForms.xml",
                local: true,
                fields: getFields("AddProductGeo", PROD_FORMS),
                appContext: "catalog"
            }),
            listForm: new OfbizList({
                listFormLocation: "component://kwikstore/widget/ProductForms.xml",
                listFormName: "ListProductGeos",
                listType: "grid",
                columnFields: getFields("ListProductGeos", PROD_FORMS),
                columnFieldTitles: getColumnFieldTitles("ListProductGeos", PROD_FORMS),
                remoteFormData: {
                    formData: {
                        formName: "ListProductGeos",
                        formLocation: "component://kwikstore/widget/ProductForms.xml",
                        listType: "grid",
                        entityName: "",
                        viewIndex: 0,
                        viewSize: 20
                    }
                },
                appContext: "catalog",
                idFieldName: "productId",
                emptyListMessage: "No geographies found for this product.  Please add."
            })
        },
        {
            title: "IDs",
            titleGroup: "Product Classification",
            path: "ids",
            keyMap: { fieldName: "productId" },
            addContainerTitle: "Add Good Identification to product",
            listContainerTitle: "Product Good Identifications",
            addFormName: "AddProductGoodIdentification",
            listFormName: "UpdateProductGoodIdentifications",
            addForm: new OfbizForm({
                formName: "AddProductGoodIdentification",
                formLocation: "component://kwikstore/widget/ProductForms.xml",
                appContext: "catalog",
                fields: getFields("AddProductGoodIdentification", PROD_FORMS),
                local: true,
            }),
            listForm: new OfbizList({
                listFormName: "UpdateProductGoodIdentifications",
                listFormLocation: "component://kwikstore/widget/ProductForms.xml",
                listType: "grid",
                appContext: "catalog",
                columnFields: getFields("UpdateProductGoodIdentifications", PROD_FORMS),
                columnFieldTitles: getColumnFieldTitles("UpdateProductGoodIdentifications", PROD_FORMS),
                emptyListMessage: "No identifications found for this product.  Please add exisiting or create new.",
                remoteFormData: {
                    formData: {
                        formName: "UpdateProductGoodIdentifications",
                        formLocation: "component://kwikstore/widget/ProductForms.xml",
                        listType: "grid",
                        viewIndex: 1,
                    },
                    appContext: "catalog",
                    parameters: { "productCategoryId": "" }
                }
            })
        },
        {
            title: "Categories",
            titleGroup: "Product Classification",
            path: "categories",
            keyMap: { fieldName: "productId" },
            addContainerTitle: "Add Product to Product Category",
            listContainerTitle: "Product Categories for this product",
            addFormName: "AddProductCategoryMember",
            listFormName: "UpdateProductCategoryMember",
            addForm: new OfbizForm({
                formName: "AddProductCategoryMember",
                formLocation: "component://kwikstore/widget/ProductForms.xml",
                local: true,
                appContext: "catalog",
                fields: getFields("AddProductCategoryMember", PROD_FORMS),
                layout: "SingleColumn"
            }),
            listForm: new OfbizList({
                listType: "grid",
                listFormName: "UpdateProductCategoryMember",
                listFormLocation: "component://kwikstore/widget/ProductForms.xml",
                columnFields: getFields("UpdateProductCategoryMember", PROD_FORMS),
                columnFieldTitles: getColumnFieldTitles("UpdateProductCategoryMember", PROD_FORMS),
                appContext: "catalog",
                findParameters: [{ "productId": "" }],
                emptyListMessage: "No categories associated with this product.  Please add existing or create new.",
                remoteFormData: {
                    formData: {
                        formName: "UpdateProductCategoryMember",
                        formLocation: "component://kwikstore/widget/ProductForms.xml",
                        listType: "grid",
                        viewIndex: 1,
                    },
                    appContext: "catalog",
                    parameters: { "productCategoryId": "" }
                }
            })
        },
        {
            title: "Keywords",
            titleGroup: "Product Classification",
            path: "keywords",
            keyMap: { fieldName: "productId" },
            addContainerTitle: "Add Product Keyword",
            listContainerTitle: "Keywords for this product",
            addFormName: "AddProductKeyword",
            listFormName: "UpdateProductKeyword",
            addForm: new OfbizForm({
                local: true,
                formName: "AddProductKeyword",
                formLocation: "component://kwikstore/widget/ProductForms.xml",
                fields: getFields("AddProductKeyword", PROD_FORMS),
                appContext: "catalog"
            }),
            listForm: new OfbizList({
                listType: "grid",
                listFormName: "UpdateProductKeyword",
                listFormLocation: "component://kwikstore/widget/ProductForms.xml",
                appContext: "catalog",
                columnFields: getFields("UpdateProductKeyword", PROD_FORMS),
                columnFieldTitles: getColumnFieldTitles("UpdateProductKeyword", PROD_FORMS),
                emptyListMessage: "No keywords found for this product. Please create new.",
                remoteFormData: {
                    formData: {
                        formName: "UpdateProductKeyword",
                        formLocation: "component://kwikstore/widget/ProductForms.xml",
                        listType: "grid",
                        viewIndex: 1,
                    },
                    appContext: "catalog",
                    parameters: { "productCategoryId": "" }
                }
            })
        },
        {
            title: "Associations",
            titleGroup: "Product Classification",
            keyMap: { fieldName: "productId" },
            addContainerTitle: "Add an associated product to this product",
            listContainerTitle: "Products associated to this product",
            addFormName: "",
            listFormName: "ListProductAssocs",
            addForm: new OfbizForm({
                local: true,
                formName: "EditProductAssoc",
                formLocation: "component://kwikstore/widget/ProductForms.xml",
                fields: getFields("EditProductAssoc", PROD_FORMS),
                appContext: "catalog"
            }),
            listForm: new OfbizList({
                listType: "grid",
                listFormName: "ListProductAssocs",
                listFormLocation: "component://kwikstore/widget/ProductForms.xml",
                columnFields: getFields("ListProductAssocs", PROD_FORMS),
                columnFieldTitles: getColumnFieldTitles("ListProductAssocs", PROD_FORMS),
                remoteFormData: {
                    formData: {
                        formName: "ListProductAssocs",
                        formLocation: "component://kwikstore/widget/ProductForms.xml",
                        listType: "grid",
                        entityName: "",
                        viewIndex: 0,
                        viewSize: 20
                    }
                },
                appContext: "catalog",
                emptyListMessage: "No proucts currently associated with this product.  Associate existing product."
            })
        },
        /* {
        title:"Manufacturing",
        titleGroup:"Product Acquisition",
        keyMap:{fieldName:"productId"},
        addContainerTitle:"",
        listContainerTitle:"",
        addFormName:"",
        listFormName:"",
        addForm:undefined,
        listForm:new OfbizList({
            emptyListMessage:""
        })
        }, */
        {
            title: "Costs",
            titleGroup: "Product Acquisition",
            path: "costs",
            keyMap: { fieldName: "productId" },
            addContainerTitle: "Add a Cost Components to this product",
            listContainerTitle: "Cost Components for this product",
            addFormName: "EditCostComponent",
            listFormName: "ListCostComponents",
            addForm: new OfbizForm({
                formName: "EditCostComponent",
                formLocation: "component://kwikstore/widget/ProductForms.xml",
                local: true,
                fields: getFields("EditCostComponent", PROD_FORMS),
                appContext: "catalog"
            }),
            listForm: new OfbizList({
                listFormName: "ListCostComponents",
                listFormLocation: "component://kwikstore/widget/ProductForms.xml",
                listType: "grid",
                columnFields: getFields("ListCostComponents", PROD_FORMS),
                columnFieldTitles: getColumnFieldTitles("ListCostComponents", PROD_FORMS),
                remoteFormData: {
                    formData: {
                        formName: "ListCostComponents",
                        formLocation: "component://kwikstore/widget/ProductForms.xml",
                        listType: "grid",
                        entityName: "",
                        viewIndex: 0,
                        viewSize: 20
                    }
                },
                appContext: "catalog",
                emptyListMessage: "No cost components for this product"
            })
        },
        {
            title: "Attributes",
            titleGroup: "Product Classification",
            path: "attributes",
            keyMap: { fieldName: "productId" },
            addContainerTitle: "Add an attribute to this product",
            listContainerTitle: "Attributes for this product",
            addFormName: "AddProductAttribute",
            listFormName: "UpdateProductAttribute",
            addForm: new OfbizForm({
                formName: "AddProductAttribute",
                formLocation: "component://kwikstore/widget/ProductForms.xml",
                local: true,
                fields: getFields("AddProductAttribute", PROD_FORMS),
                appContext: "catalog"
            }),
            listForm: new OfbizList({
                listType: "grid",
                listFormName: "UpdateProductAttribute",
                listFormLocation: "component://kwikstore/widget/ProductForms.xml",
                appContext: "catalog",
                columnFields: getFields("UpdateProductAttribute", PROD_FORMS),
                columnFieldTitles: getColumnFieldTitles("UpdateProductAttribute", PROD_FORMS),
                emptyListMessage: "No attributes for this product",
                remoteFormData: {
                    formData: {
                        formName: "UpdateProductAttribute",
                        formLocation: "component://kwikstore/widget/ProductForms.xml",
                        listType: "grid",
                        viewIndex: 1,
                    },
                    appContext: "catalog",
                    parameters: { "productCategoryId": "" }
                }
            })
        },
        {
            title: "Features",
            titleGroup: "Product Classification",
            keyMap: { fieldName: "productId" },
            addContainerTitle: "Add a feature for this product",
            listContainerTitle: "Features for this product",
            addFormName: "AddProductFeatureApplAttrRest",
            listFormName: "ListProductFeatureApplAttrsRest",
            addForm: new OfbizForm({
                formName: "AddProductFeatureApplAttrRest",
                formLocation: "component://kwikstore/widget/ProductForms.xml",
                local: true,
                appContext: "catalog",
                fields: getFields("AddProductFeatureApplAttrRest", PROD_FORMS)
            }),
            listForm: new OfbizList({
                listFormName: "ListProductFeatureApplAttrsRest",
                listFormLocation: "component://kwikstore/widget/ProductForms.xml",
                listType: "grid",
                columnFields: getFields("ListProductFeatureApplAttrsRest", PROD_FORMS),
                columnFieldTitles: getColumnFieldTitles("ListProductFeatureApplAttrsRest", PROD_FORMS),
                remoteFormData: {
                    formData: {
                        formName: "ListProductFeatureApplAttrsRest",
                        formLocation: "component://kwikstore/widget/ProductForms.xml",
                        listType: "grid",
                        entityName: "",
                        viewIndex: 0,
                        viewSize: 20
                    }
                },
                appContext: "catalog",
                emptyListMessage: "No features listed for this product"
            })
        },
        {
            title: "Facilities",
            titleGroup: "Product Storage",
            path: "facilities",
            keyMap: { fieldName: "productId" },
            addContainerTitle: "Associate a facility to this product",
            listContainerTitle: "Facilities listed for this product",
            addFormName: "AddProductFacility",
            listFormName: "UpdateProductFacilities",
            addForm: new OfbizForm({
                formName: "AddProductFacility",
                formLocation: "component://kwikstore/widget/ProductForms.xml",
                local: true,
                fields: getFields("AddProductFacility", PROD_FORMS),
                appContext: "catalog"
            }),
            listForm: new OfbizList({
                listFormName: "UpdateProductFacilities",
                listFormLocation: "component://kwikstore/widget/ProductForms.xml",
                listType: "grid",
                columnFields: getFields("UpdateProductFacilities", PROD_FORMS),
                columnFieldTitles: getColumnFieldTitles("UpdateProductFacilities", PROD_FORMS),
                emptyListMessage: "No facilities associated with this product",
                remoteFormData: {
                    formData: {
                        formName: "UpdateProductFacilities",
                        formLocation: "component://kwikstore/widget/ProductForms.xml",
                        listType: "grid",
                        viewIndex: 1,
                    },
                    parameters: { "productCategoryId": "" }
                },
                appContext: "catalog",
            })
        },
        {
            title: "Locations",
            titleGroup: "Product Classification",
            path: "locations",
            keyMap: { fieldName: "productId" },
            addContainerTitle: "",
            listContainerTitle: "",
            addFormName: "",
            listFormName: "",
            addForm: undefined,
            listForm: new OfbizList({
                listFormName: "",
                listFormLocation: "",
                columnFields: [],
                columnFieldTitles: [],
                remoteFormData: {
                    formData: {
                        formName: "",
                        formLocation: "",
                        listType: "",
                        entityName: "",
                        viewIndex: 0,
                        viewSize: 0
                    }
                },
                emptyListMessage: ""
            })
        },
        {
            title: "Inventory",
            titleGroup: "Product Storage",
            path: "inventory",
            keyMap: { fieldName: "productId" },
            addContainerTitle: "",
            listContainerTitle: "",
            addFormName: "",
            listFormName: "",
            addForm: undefined,
            listForm: new OfbizList({
                listFormName: "",
                listFormLocation: "",
                columnFields: [],
                columnFieldTitles: [],
                remoteFormData: {
                    formData: {
                        formName: "",
                        formLocation: "",
                        listType: "",
                        entityName: "",
                        viewIndex: 0,
                        viewSize: 0
                    }
                },
                emptyListMessage: ""
            })
        },
        {
            title: "Suppliers",
            titleGroup: "Product Acquisition",
            keyMap: { fieldName: "productId" },
            addContainerTitle: "",
            listContainerTitle: "",
            addFormName: "",
            listFormName: "",
            addForm: undefined,
            listForm: new OfbizList({
                listFormName: "",
                listFormLocation: "",
                columnFields: [],
                columnFieldTitles: [],
                remoteFormData: {
                    formData: {
                        formName: "",
                        formLocation: "",
                        listType: "",
                        entityName: "",
                        viewIndex: 0,
                        viewSize: 0
                    }
                },
                emptyListMessage: ""
            })
        },
        {
            title: "Agreements",
            titleGroup: "Product Acquisition",
            keyMap: { fieldName: "productId" },
            addContainerTitle: "",
            listContainerTitle: "",
            addFormName: "",
            listFormName: "",
            addForm: undefined,
            listForm: new OfbizList({
                listFormName: "",
                listFormLocation: "",
                columnFields: [],
                columnFieldTitles: [],
                remoteFormData: {
                    formData: {
                        formName: "",
                        formLocation: "",
                        listType: "",
                        entityName: "",
                        viewIndex: 0,
                        viewSize: 0
                    }
                },
                emptyListMessage: ""
            })
        },
        {
            title: "Accounts",
            titleGroup: "Product Financials",
            keyMap: { fieldName: "productId" },
            addContainerTitle: "",
            listContainerTitle: "",
            addFormName: "",
            listFormName: "",
            addForm: undefined,
            listForm: new OfbizList({
                listFormName: "",
                listFormLocation: "",
                columnFields: [],
                columnFieldTitles: [],
                remoteFormData: {
                    formData: {
                        formName: "",
                        formLocation: "",
                        listType: "",
                        entityName: "",
                        viewIndex: 0,
                        viewSize: 0
                    }
                },
                emptyListMessage: ""
            })
        },
        {
            title: "Payment Types",
            titleGroup: "Product Financials",
            keyMap: { fieldName: "productId" },
            addContainerTitle: "",
            listContainerTitle: "",
            addFormName: "",
            listFormName: "",
            addForm: undefined,
            listForm: new OfbizList({
                listFormName: "",
                listFormLocation: "",
                columnFields: [],
                columnFieldTitles: [],
                remoteFormData: {
                    formData: {
                        formName: "",
                        formLocation: "",
                        listType: "",
                        entityName: "",
                        viewIndex: 0,
                        viewSize: 0
                    }
                },
                emptyListMessage: ""
            })
        },
        {
            title: "Maintenance",
            titleGroup: "Product Storage",
            keyMap: { fieldName: "productId" },
            addContainerTitle: "",
            listContainerTitle: "",
            addFormName: "",
            listFormName: "",
            addForm: undefined,
            listForm: new OfbizList({
                listFormName: "",
                listFormLocation: "",
                columnFields: [],
                columnFieldTitles: [],
                remoteFormData: {
                    formData: {
                        formName: "",
                        formLocation: "",
                        listType: "",
                        entityName: "",
                        viewIndex: 0,
                        viewSize: 0
                    }
                },
                emptyListMessage: ""
            })
        },
        {
            title: "Meters",
            titleGroup: "Product Classification",
            keyMap: { fieldName: "productId" },
            addContainerTitle: "",
            listContainerTitle: "",
            addFormName: "",
            listFormName: "",
            addForm: undefined,
            listForm: new OfbizList({
                listFormName: "",
                listFormLocation: "",
                columnFields: [],
                columnFieldTitles: [],
                remoteFormData: {
                    formData: {
                        formName: "",
                        formLocation: "",
                        listType: "",
                        entityName: "",
                        viewIndex: 0,
                        viewSize: 0
                    }
                },
                emptyListMessage: ""
            })
        },
        {
            title: "Subscription Resources",
            keyMap: { fieldName: "productId" },
            addContainerTitle: "",
            listContainerTitle: "",
            addFormName: "",
            listFormName: "",
            addForm: undefined,
            listForm: new OfbizList({
                listFormName: "",
                listFormLocation: "",
                columnFields: [],
                columnFieldTitles: [],
                remoteFormData: {
                    formData: {
                        formName: "",
                        formLocation: "",
                        listType: "",
                        entityName: "",
                        viewIndex: 0,
                        viewSize: 0
                    }
                },
                emptyListMessage: ""
            })
        },
        {
            title: "Quick Admin",
            keyMap: { fieldName: "productId" },
            addContainerTitle: "",
            listContainerTitle: "",
            addFormName: "",
            listFormName: "",
            addForm: undefined,
            listForm: new OfbizList({
                listFormName: "",
                listFormLocation: "",
                columnFields: [],
                columnFieldTitles: [],
                remoteFormData: {
                    formData: {
                        formName: "",
                        formLocation: "",
                        listType: "",
                        entityName: "",
                        viewIndex: 0,
                        viewSize: 0
                    }
                },
                emptyListMessage: ""
            })
        },
        {
            title: "Vendor",
            titleGroup: "Product Acquisition",
            keyMap: { fieldName: "productId" },
            addContainerTitle: "",
            listContainerTitle: "",
            addFormName: "",
            listFormName: "",
            addForm: undefined,
            listForm: new OfbizList({
                listFormName: "",
                listFormLocation: "",
                columnFields: [],
                columnFieldTitles: [],
                remoteFormData: {
                    formData: {
                        formName: "",
                        formLocation: "",
                        listType: "",
                        entityName: "",
                        viewIndex: 0,
                        viewSize: 0
                    }
                },
                emptyListMessage: ""
            })
        },
        {
            title: "Work Efforts",
            keyMap: { fieldName: "productId" },
            addContainerTitle: "Create new Tasks for this product",
            listContainerTitle: "Tasks List for this product",
            addFormName: "AddProductWorkEffortRest",
            listFormName: "ListProductWorkEffortsRest",
            addForm: new OfbizForm({
                local: true,
                formName: "AddProductWorkEffortRest",
                formLocation: "component://kwikstore/widget/ProductForms.xml",
                fields: getFields("AddProductWorkEffortRest", PROD_FORMS),
                idFieldName: "productId",
                appContext: "catalog"
            }),
            listForm: new OfbizList({
                listFormLocation: "component://kwikstore/widget/ProductForms.xml",
                listFormName: "ListProductWorkEffortsRest",
                listType: "grid",
                columnFields: getFields("ListProductWorkEffortsRest", PROD_FORMS),
                columnFieldTitles: getColumnFieldTitles("ListProductWorkEffortsRest", PROD_FORMS),
                remoteFormData: {
                    formData: {
                        formName: "ListProductWorkEffortsRest",
                        formLocation: "component://kwikstore/widget/ProductForms.xml",
                        listType: "grid",
                        viewIndex: 0,
                        viewSize: 20
                    }
                },
                appContext: "catalog",
                emptyListMessage: "No existing Tasks associated with this product.  Please add existing or create new"
            })
        },
        {
            title: "Parties",
            keyMap: { fieldName: "productId" },
            addContainerTitle: "Add existing people/organisations to this product",
            listContainerTitle: "People/Organisations associated with this product",
            addFormName: "AddProductRoleRest",
            listFormName: "",
            addForm: new OfbizForm({
                local: true,
                formName: "AddProductRoleRest",
                formLocation: "component://kwikstore/widget/ProductForms.xml",
                fields: getFields("AddProductRoleRest", PROD_FORMS),
                idFieldName: "productId",
                appContext: "catalog"
            }),
            listForm: new OfbizList({
                listFormName: "UpdateProductRoleRest",
                listFormLocation: "component://kwikstore/widget/ProductForms.xml",
                columnFields: getFields("UpdateProductRoleRest", PROD_FORMS),
                columnFieldTitles: getColumnFieldTitles("UpdateProductRoleRest", PROD_FORMS),
                appContext: "catalog",
                remoteFormData: {
                    formData: {
                        formName: "UpdateProductRoleRest",
                        formLocation: "component://kwikstore/widget/ProductForms.xml",
                        listType: "grid",
                        viewIndex: 0,
                        viewSize: 20
                    }
                },
                listType: "grid",
                emptyListMessage: ""
            })
        },
        {
            title: "Orders",
            titleGroup: "Product Financials",
            keyMap: { fieldName: "productId" },
            addContainerTitle: "",
            listContainerTitle: "",
            addFormName: "",
            listFormName: "",
            addForm: undefined,
            listForm: new OfbizList({
                listFormName: "",
                listFormLocation: "",
                columnFields: [],
                columnFieldTitles: [],
                remoteFormData: {
                    formData: {
                        formName: "",
                        formLocation: ""
                    }
                },
                emptyListMessage: ""
            })
        },
        {
            title: "Communications",
            keyMap: { fieldName: "productId" },
            addContainerTitle: "Add existing communication to this product",
            listContainerTitle: "Communications asociated with this product",
            addFormName: "EditCommEventRest",
            listFormName: "ListCommEventsRest",
            addForm: new OfbizForm({
                local: true,
                formLocation: "component://kwikstore/widget/ProductForms.xml",
                formName: "EditCommEventRest",
                fields: getFields("EditCommEventRest", PROD_FORMS),
                appContext: "catalog",
            }),
            listForm: new OfbizList({
                listFormName: "ListCommEventsRest",
                listFormLocation: "component://kwikstore/widget/ProductForms.xml",
                listType: "grid",
                columnFields: getFields("ListCommEventsRest", PROD_FORMS),
                columnFieldTitles: getColumnFieldTitles("ListCommEventsRest", PROD_FORMS),
                remoteFormData: {
                    formData: {
                        formName: "ListCommEventsRest",
                        formLocation: "component://kwikstore/widget/ProductForms.xml",
                        viewIndex: 0,
                        viewSize: 20
                    }
                },
                emptyListMessage: "No communication associated with this product.  Add existing or create new.",
                appContext: "catalog"
            })
        },
        {
            title: "Group Order",
            titleGroup: "Product Financials",
            keyMap: { fieldName: "productId" },
            addContainerTitle: "",
            listContainerTitle: "",
            addFormName: "",
            listFormName: "",
            addForm: undefined,
            listForm: new OfbizList({
                listFormName: "",
                listFormLocation: "",
                listType: "",
                columnFields: [],
                columnFieldTitles: [],
                remoteFormData: {
                    formData: {
                        formName: "",
                        formLocation: ""
                    }
                },
                emptyListMessage: ""
            })
        },
    ],
    customContainerItems: [
        new CustomContainerItem("EditProduct", ProductEditContainerComponent, {})
    ],
    outGoingLinks: [
        {
            target: "",
            targetType: ""
        }
    ],
    assistant: {
        enabled: false,
        name: "Product Configuration Assistant",
        path: "products/product",
        capabilities: [
            {
                type: "categorise",
                description: "Hi, I can help you configure a new product for your store.",
                requiredFields: ["productId", "internalName"],
                contextualHint: "Use this assistant to configure a new product instead of using a form."
            }
        ],
        contextualTriggers: { onCreate: true },
        defaultPrompts: {
            key: "Give a general description of the product, eg 'men's sport shoes'"
        },
        uiPosition: 'sidebar',
        serverEndpoints: {
            "categorise": "/api/categories"
        }
    }

}

/* export function getFields(formName:string,FORMS):any[]{
    let fields:any[];
    let columnFieldTitles:ColumnFieldTitle[];
    let localForm = FORMS.find(form => form.name == formName || form.formName == formName);
    if(localForm){
        fields = localForm.fields;
        columnFieldTitles = columnFieldTitles = localForm.columns;
        if(columnFieldTitles != undefined && columnFieldTitles.length > 0){
            fields.forEach(field => {
                let columnField = columnFieldTitles.find(element => element.name == field.name);
                if(columnField){
                    field.title = columnField.title;
                }
            })

        }
    }
    return fields;
} */

export function getColumnFieldTitles(formName: string, FORMS: any[]): ColumnFieldTitle[] {
    let columnFieldTitles: any[];
    const localForm = FORMS.find(form => form.name == formName || form.formName == formName);
    if (localForm && localForm.columns) {
        columnFieldTitles = localForm.columns;
    }
    console.log({ columnFieldTitles: columnFieldTitles, "formName": formName });
    return columnFieldTitles
}

export function getTitleDescriptionField(formName: string, FORMS): string {
    const localForm = FORMS.find(form => form.name == formName || form.formName == formName);
    const fieldName = localForm.titleDescriptionField ? localForm.titleDescriptionField : "";
    return fieldName;
}

export function getIdFieldName(formName: string, FORMS): string {
    const localForm = FORMS.find(form => form.name == formName || form.formName == formName);
    const fieldName = localForm.idFieldName ? localForm.idFieldName : "";
    return fieldName;
}

export function getFieldSets(formName: string, FORMS): FieldSet[] {
    let fieldSets = [];
    const localForm = FORMS.find(form => form.name == formName || form.formName == formName);
    fieldSets = localForm.fieldSets;
    return fieldSets;
}

export function getTarget(formName: string, FORMS): string {
    let target = "";
    const localForm = FORMS.find(form => form.name == formName || form.formName == formName);
    target = localForm.target;
    return target;
}
